import ExperienceGrid from './components/experience-grid';
import MouseNext from './components/mouse-next';
import FixedNavbar from './components/fixed-navbar/fixed-navbar';
import GoogleMapsLoader from './components/google-maps-loader';
import CompareRooms from './components/room-compare';
import OffcanvasMenu from './components/offcanvas-menu';
import DatePicker from './components/date-picker';
import HeroSlider from "./components/hero-slider";
import Parallax from "./components/parallax";
import ScaleImage from "./components/scale-image";

gsap.registerPlugin(ScrollTrigger);

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {

		if (Array.from(document.querySelectorAll('.flexible-section-view-also')).length > 0) {
			Array.from(document.querySelectorAll('.flexible-section-view-also')).map(flexible_section => {
				const swiper = flexible_section.querySelector('.swiper.swiper-images');
				const swiperThumb = flexible_section.querySelector('.swiper.swiper-thumbs');
				const currentSlide = flexible_section.querySelector('.counter span');

				swiperThumb.swiper.on('slideChange', function (swiper) {
					if (currentSlide) {
						currentSlide.innerText = swiper.realIndex + 1;
					}
				});

				swiper.closest('.clickable-area').addEventListener('click', () => {
					swiperThumb.swiper.slideNext();
				});
			});
		}

		if (Array.from(document.querySelectorAll('.room-gallery')).length > 0) {
			Array.from(document.querySelectorAll('.room-gallery')).map(room_gallery => {
				const swiper = room_gallery.querySelector('.swiper');

				swiper.closest('.clickable-area').addEventListener('click', () => {
					swiper.swiper.slideNext();
				});
			});
		}

		if (Array.from(document.querySelectorAll('.mouse-next')).length > 0) {
			Array.from(document.querySelectorAll('.mouse-next')).map((el) => new MouseNext(el));
		}

		if (Array.from(document.querySelectorAll('.filters-list button')).length > 0) {
			const roomsListSection = document.querySelector('.flexible-section-rooms-list');
			Array.from(document.querySelectorAll('.filters-list button')).map(filter => {
				filter.addEventListener('click', () => {
					roomsListSection.scrollIntoView({ behavior: "smooth"});
				});
			});
		}

		const checkin = document.getElementById('checkin-picker');
		const checkout = document.getElementById('checkout-picker');

		if (checkin && checkout) {
			new DatePicker(checkin,checkout);
		}

		// Experience Grid
		if (Array.from(document.querySelectorAll('.flexible-section-experiences-grid')).length > 0) {
			Array.from(document.querySelectorAll('.flexible-section-experiences-grid')).map(el => new ExperienceGrid(el));
		}

		if (document.getElementById('wrapper-navbar')) {
			new FixedNavbar(document.getElementById('wrapper-navbar'));
		}

		if (Array.from(document.querySelectorAll('.map')).length > 0) {
			Array.from(document.querySelectorAll('.map')).map(el => new GoogleMapsLoader(el));
		}

		// Room Compare Functionality
		if (document.getElementById('room-compare-form')) {
			new CompareRooms();
		}

		// Swiper on Home Hero Section
		if (document.querySelector('.hero-home-section.swiper') && document.querySelector('.slider-thumbs')) {
			const swiperObj = document.querySelector('.hero-home-section.swiper').swiper;
			const thumbs = Array.from(document.querySelectorAll('.slider-thumbs li a[data-index]'));

			swiperObj.on('slideChange', function (sw) {
				if (sw.slides[sw.realIndex].querySelector('video')) {
					sw.el.querySelector('.titles-wrapper').classList.add('inactive');
				} else {
					sw.el.querySelector('.titles-wrapper').classList.remove('inactive');
				}
			});

			thumbs && thumbs.map(thumb => {
				thumb.addEventListener('click', (ev) => {
					ev.preventDefault();
					swiperObj.slideTo( ev.currentTarget.dataset.index );
					thumbs.map(th => th.classList.remove('is-active'));
					thumb.classList.add('is-active');
				});
			});
		}

		// Off-canvas animations
		if (document.getElementById('navbarNavOffcanvas')) {
			new OffcanvasMenu(document.getElementById('navbarNavOffcanvas'));
		}

		// HeroSlider
		if (document.querySelector('.hero-home-section')) {
			const tmp = new HeroSlider(document.querySelector('.hero-home-section'));
		}

		// Observer for fade-in-me effect
		let observerOptions = {
			// threshold: [0, 1]
		};
		let observerEffectFade = new IntersectionObserver(function (entries) {
			entries.map(function (entry, index) {
				if (entry.isIntersecting) {
					setTimeout(function () {
						entry.target.classList.add('is-in-view');
						observerEffectFade.unobserve(entry.target);
					}, 50 * index);
				}
			});
		}, observerOptions);
		document.querySelectorAll('.fade-in-me, .slide-in-me').forEach(function (observable) {
			return observerEffectFade.observe(observable);
		});

		// Effect: Parallax
		if (document.querySelectorAll('.parallax').length > 0) {
			const parallax = new Parallax('.parallax');
		}

		// Effect: Scale images
		if (document.querySelectorAll('.scale-image').length > 0) {
			const scaleImage = new ScaleImage('.scale-image');
		}

		// document.addEventListener("DOMContentLoaded",function() {
		// 	if ("https://www.koiaresort.com/el/restaurants/elixir-bar/" === window.location.href) {
		// 		var t = document.querySelector(".room-hero a.koia-button-outline");
		// 	}
		// 	t && (t.href = "https://www.koiaresort.com/app/uploads/sites/140/2024/05/2024_FOR_INTERNET_ElixirBar_with_el.pdf");
		// });
	}
};

domLoaded(() => {
	App.init();
});
